import { Box } from '@mui/material'
import KeyVaultNav from './KeyVaultNav'
import KeyVaultRoutes from './KeyVaultRoutes'

const KeyVaultLayout = () => {
  return (
    <>
      <KeyVaultNav />
      <Box sx={{ px: 3 }}>
        <KeyVaultRoutes />
      </Box>
    </>
  )
}

export default KeyVaultLayout
